import { Asterisk } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export default function Marquee() {
  const content = useContent();
  const row = [...content.marquee, ...content.marquee];
  return (
    <section data-testid="marquee-section" className="relative overflow-hidden border-y border-gold/15 bg-obsidian-800 py-6">
      <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap">
        {row.map((item, i) => (
          <div key={i} className="flex items-center gap-8">
            <span
              className={`font-display text-3xl font-extrabold uppercase tracking-tight sm:text-4xl ${
                i % 2 === 0 ? "text-zinc-100" : "text-outline-gold"
              }`}
            >
              {item}
            </span>
            <Asterisk className="h-6 w-6 shrink-0 text-gold" />
          </div>
        ))}
      </div>
    </section>
  );
}
